import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { map, Observable } from 'rxjs';
import { BOMHeader } from 'src/app/models';
import { BOMHeaderAdapter } from 'src/app/models/domain/adapters/bom-header-adapter';
import { IBomHeaderPost } from 'src/app/models/domain/bom-header-post';
import { IBomHeader } from 'src/app/state/bom-header/bom-header.model';

@Injectable({
  providedIn: 'root',
})
export class BomHeaderApiService {
  public constructor(
    private readonly httpClient: HttpClient,
    private readonly adapter: BOMHeaderAdapter
  ) {}

  public getSingle(designId: string): Observable<IBomHeader> {
    return this.httpClient.get<IBomHeader>(`api/bom-header/${designId}`).pipe(rethrowAsSapError());
  }

  public lockBOM(designId: string): Observable<void> {
    const updateModel = this.createBOMStatus();

    return this.httpClient
      .patch<unknown>(`api/bom-header/${designId}`, this.adapter.adaptToDTO(updateModel))
      .pipe(
        map(() => undefined) // map response to void
      );
  }

  private createBOMStatus(): Partial<BOMHeader> {
    return { status: 22 };
  }

  private createNewBomHeader(designId: string): Partial<IBomHeaderPost> {
    return this.adapter.adaptToPost({ altBom: '1', plant: '500', usage: 'M', material: designId });
  }

  public createMaterialBom(designId: string): Observable<IBomHeader> {
    return this.httpClient.post<IBomHeader>(
      `api/bom-header/${designId}`,
      this.createNewBomHeader(designId)
    );
  }
}
